import * as ng from 'angular';
import { PanelHeaderData } from '../../../atomic-components/molecules/panels/panel-header/panel-header';

export class TemplateDatabaseUserOverviewController {
    public static $inject: string[] = ['$translate'];

    public pageHeaderData: PanelHeaderData;
    public bundle: any;
    public overviewServiceData;
    public expertView: boolean;
    public overviewModel: any;
    public faqArticleIdList: string[] = [
        'webspace-ftp-access',
        'webspace-file-directory',
        'webspace-ftp-folders'
    ];
    private simpleFilter;
    private extendedFilters: any;
    private overviewUiSettings;

    constructor(private $translate: ng.translate.ITranslateService) {}

    public $onInit() {
        if ([undefined, null].indexOf(this.simpleFilter) === -1) {
            this.expertView = this.overviewUiSettings.expertView || this.simpleFilter.show;
        } else {
            this.expertView = this.overviewUiSettings.expertView || false;
        }

        this.pageHeaderData = {
            backwardLink: 'database.databases.overview',
            backwardText: this.$translate.instant('TR_100119-12711e_TR'),
            panelHeaderRoute: 'database.databases.overview',
            panelHeaderRouteParams: null,
            panelIcon: 'folder-open',
            panelTitle: this.$translate.instant('TR_100119-de042d_TR')
        };

        this.overviewServiceData = {
            extendedFilters: this.extendedFilters,
            fancyFilterExpand: this.expertView,
            overviewUiSettings: this.overviewUiSettings,
            simpleFilter: this.simpleFilter
        };
    }

    public expandWrapper = (toggle) => {
        this.expertView = toggle.expand;
    };
}

export class TemplateDatabaseUserOverviewComponent implements ng.IComponentOptions {
    public bindings = {
        extendedFilters: '<',
        overviewModel: '<',
        overviewUiSettings: '<',
        simpleFilter: '<'
    };
    public controller = TemplateDatabaseUserOverviewController;
    public controllerAs = 'TemplateDatabaseUserOverviewCtrl';
    public template = require('./user-overview-template.html');
}
